export const ValueChart = ({ value }) => {
  return <div className='text-2xl p-4 h-36 flex items-center justify-center'>{value || 0}</div>;
};
